<template>
  <v-container fluid class="pa-sm-5 px-1 mobile-height">
    <div v-if="$route.name === 'project'">
      <skeleton v-show="$apollo.queries.project.loading" />
      <project-component :project="project" v-if="project && !editMode && !$apollo.queries.project.loading" @commentFocus="commentFocus = !commentFocus" @editClicked="handleEditClicked" :current-user="currentUser" :apply="apply" @refetchProject="refetchProject"/>
      <edit :project="project" v-if="project && editMode" @updateDone="handleUpdateDone"/>
      <comments v-if="!editMode && !error" :current-user="currentUser" :loading="$apollo.queries.project.loading" :comment-focus="commentFocus" :threadId="this.id"/>
      <div class="mt-16" v-if="project && project.isMine"></div>
      <not-found v-if="error"/>
    </div>
  </v-container>
</template>

<script>
import ProjectComponent from '../components/ProjectComponent'
import NotFound from '../components/ProjectComponent/NotFound'
import Edit from '../components/ProjectComponent/Edit'
import Comments from '../components/ProjectComponent/Comments'
import Skeleton from '../components/Utils/Skeleton'
import PROJECT from '../graphql/singleProject.graphql'
export default {
  props: {
    id: {
      default: null
    },
    currentUser: {
      type: Object,
      default: () => {}
    }
  },
  apollo: {
    project: {
      query: PROJECT,
      fetchPolicy: 'network-only',
      variables () {
        return {
          id: this.id
        }
      },
      error (err) {
        this.error = err
      }
    }
  },
  data () {
    return {
      commentFocus: false,
      editMode: false,
      apply: false,
      error: null
    }
  },
  mounted () {
    let apply = this.$route.query.apply && (this.$route.query.apply).toString()
    if (apply === 'true') {
      apply = true
      this.$router.replace(this.$route.path)
    }
    this.apply = apply
  },
  methods: {
    handleEditClicked () {
      this.editMode = true
    },
    handleUpdateDone () {
      this.editMode = false
      this.$apollo.queries.project.refetch()
    },
    preventNav (event) {
      if (!this.editMode) return
      event.preventDefault()
      event.returnValue = ''
    },
    refetchProject () {
      this.$apollo.queries.project.refetch()
    }
  },
  components: {
    ProjectComponent,
    Skeleton,
    Edit,
    NotFound,
    Comments
  },
  beforeRouteLeave (to, from, next) {
    if (this.editMode) {
      this.editMode = false
      next(false)
      return
    }
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('beforeunload', this.preventNav)
    })
  }
}
</script>

<style scoped>

</style>
